import portfolio from './portfolio'
import tag from './tag'

const badges = {
  portfolio,
  tag
}

export default badges
